import React, { useState } from 'react';
import { Tooltip, Typography } from '@mui/material';

/**
 * Single-line Typography with an ellipsis. Shows the full text in a Tooltip
 * only when the text is actually truncated. Internal to Components/ui.
 */
const OverflowText = ({ children, sx, ...typographyProps }) => {
  const [truncated, setTruncated] = useState(false);

  const checkTruncated = (event) => {
    const el = event.currentTarget;
    setTruncated(el.scrollWidth > el.clientWidth);
  };

  return (
    <Tooltip title={truncated ? children : ''}>
      <Typography
        noWrap
        onMouseEnter={checkTruncated}
        sx={{ minWidth: 0, ...sx }}
        {...typographyProps}
      >
        {children}
      </Typography>
    </Tooltip>
  );
};

export default OverflowText;
